export default __webpack_public_path__ + "static/media/3.7de740cc.jpg";